import { RuleDataAccessors } from '../../RuleData';
/**
 *
 * @param activeSourceCategories
 * @param ruleData
 */
export function generateActiveSources(activeSourceCategories, ruleData) {
    const sourceData = RuleDataAccessors.getSourceData(ruleData);
    return sourceData.filter((source) => activeSourceCategories.includes(source.sourceCategoryId));
}
